/** Must match the server's HEARTBEAT_INTERVAL_MS (apps/api/src/modules/work-sessions/accumulate.ts). */
export const HEARTBEAT_MS = 30_000;
